angular.module('autoremind.templates')
    .directive('uploadSelectImages', ['templateService', 'FileUploader', '$timeout', 'dialogs', '$rootScope', '$uibModal', 'Upload',
    function (templateService, FileUploader, $timeout, dialogs, $rootScope, $uibModal, Upload) {
        return {
            restrict: 'E',
            templateUrl: 'app/common/messages/upload-select-images.html',
            link: function (scope, elem, attr) {
                var baseImageUrl = 'https://images.autoremind.us/';
                scope.viewModel = {
                    selectedVar: null,
                    editedField: null,
                    modelForRevert: null,
                    variables: templateService.imageModel,
                    initialVariables: [],
                    isEdited: false,
                    isGeneralUpload: scope.config.isGeneralUpload ? scope.config.isGeneralUpload : false,
                    isUserFolder: templateService.userModel.userId ? true : false,
                    wasFileUploaded: false,
                    defaultFile: null,
                    isImagesUploaded: false,
                    imageNameIncorrect: false
                };
                scope.templateService = templateService;
                scope.createFileNameBasedOnPath = function (path) {
                    var fileName = angular.copy(path);
                    return fileName.substr(fileName.lastIndexOf('/') + 1);
                };
                scope.uploadImage = function (fileModel, file) {
                    if (!file) {
                        return;
                    }
                    fileModel.isAlreadyOnServer = false;
                    var fileType = file.type;
                    var alias = new Date().getTime() + 'R' + Math.floor(Math.random() * 9999) + '.' + (fileType.substr(fileType.lastIndexOf('/') + 1));
                    if (fileModel.file && angular.isDefined(fileModel.file.alias)) {
                        alias = fileModel.file.alias;
                    }
                    if (angular.isDefined(file) && file) {
                        fileModel.file = file;
                    }
                    fileModel.file.alias = alias;
                    fileModel.fileUploadProgress = 0;
                    scope.createFileNameAndPath(fileModel);
                    console.log('fileModel.file', fileModel.file);
                    templateService.uploadTemplateFile(fileModel.file)
                        .progress(function (evt) {
                        fileModel.fileUploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                        //                	scope.viewModel.uploadingModel.fileLoadProgress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (response, status, headers, config) {
                        scope.viewModel.isEdited = true;
                        scope.viewModel.wasFileUploaded = true;
                        scope.checkImageNameOnExistence(fileModel);
                    }).error(function (err) {
                    });
                };
                scope.getUserFolder = function () {
                    if (!scope.viewModel.isUserFolder ||
                        (scope.config.type === 'ar3' && !templateService.userModel.userId)) {
                        return '';
                    }
                    var userFolder = templateService.userModel.userId;
                    return userFolder + '/';
                };
                scope.createFileNameAndPath = function (model) {
                    var imageName = angular.copy(model.file.name);
                    var oldFileName = model.fileName.substr(0, model.fileName.lastIndexOf('/') + 1);
                    if (imageName.lastIndexOf('/') > 0) {
                        imageName = imageName.substr(imageName.lastIndexOf('/') + 1, imageName.length);
                    }
                    imageName = imageName.toLowerCase();
                    imageName = imageName.replace(/\s{1,}/g, "-");
                    var createdUrl = (oldFileName + imageName).replace(/\/{2,}/g, '/');
                    // model.src = baseImageUrl + (scope.getUserFolder() + encodeURIComponent(createdUrl)).replace(/\/{2,}/g, '/');
                    model.src = baseImageUrl + (scope.getUserFolder() + createdUrl).replace(/\/{2,}/g, '/');
                    model.fileName = (oldFileName + imageName).replace(/\/{2,}/g, '/');
                };
                scope.filterObj = { name: 'filterName1', fn: function () { console.log('this is my filter'); } };
                scope.createVariable = function () {
                    var variable = {
                        varName: moment().toDate().getTime().toString() + 'R' + Math.floor(Math.random() * 9999),
                        file: null,
                        fileName: '',
                        src: '',
                        isAlreadyOnServer: false
                    };
                    scope.viewModel.initialVariables.push(variable);
                    var index = scope.viewModel.variables.push(variable) - 1;
                    return index;
                };
                console.log('scope.uploader', scope.uploader, '----', Upload);
                scope.uploader = new FileUploader({
                    removeAfterUpload: true,
                    filters: [{
                            fn: function (item, options) {
                                if (!options.varName) {
                                    var index = scope.createVariable();
                                    scope.uploadImage(scope.viewModel.variables[index], item);
                                    return true;
                                }
                                for (var i in scope.viewModel.variables) {
                                    if (scope.viewModel.variables[i].varName === options.varName) {
                                        scope.uploadImage(scope.viewModel.variables[i], item);
                                        break;
                                    }
                                }
                                return true;
                            }
                        }]
                });
                scope.uploader.onAfterAddingAll = function (addedFileItems) {
                    scope.selectVarByFile(addedFileItems[0]._file);
                };
                scope.isExternalFile = function (url) {
                    var regexp = /autoremind\.[a-z]{2,3}/;
                    return (!url.match(regexp));
                };
                scope.getFileNameBasedOnUrl = function (url) {
                    var fileName = '';
                    if (url.length === 0 || scope.isExternalFile(url)) {
                        console.log('getFileNameBasedOnUrl', fileName);
                        return fileName;
                    }
                    /** file from external storage */
                    fileName = angular.copy(url);
                    fileName = fileName.substr(fileName.lastIndexOf('/') + 1, fileName.length);
                    console.log('getFileNameBasedOnUrl', fileName);
                    return fileName;
                };
                scope.init = function () {
                    if (!angular.isDefined(scope.model) || scope.viewModel.isGeneralUpload) {
                        scope.viewModel.variables = [];
                        scope.viewModel.initialVariables = [];
                        return;
                    }
                    scope.viewModel.initialVariables = [];
                    for (var i in scope.viewModel.variables) {
                        scope.viewModel.variables[i].fileName = scope.getFileNameBasedOnUrl(scope.viewModel.variables[i].src);
                        scope.viewModel.variables[i].isFileNameExist = false;
                        scope.viewModel.initialVariables.push(angular.copy(scope.viewModel.variables[i]));
                        if ('template.' + scope.viewModel.variables[i].varName === scope.model.modelName && scope.model.file) {
                            // scope.viewModel.variables[i].file = scope.model.file;
                            scope.uploadImage(scope.viewModel.variables[i], scope.model.file);
                            // break;
                        }
                    }
                }();
                scope.selectImage = function (id) {
                    console.log(id);
                    $timeout(function () {
                        console.log(angular.element("#" + id)[0]);
                        angular.element("#" + id).triggerHandler('click');
                    });
                };
                scope.removeImage = function (model, isExternal) {
                    if (model.file && angular.isDefined(model.file.alias)) {
                        templateService.cancelUploadImageFile(model.file.alias);
                    }
                    if (isExternal) {
                        model.file = null;
                        model.fileUploadProgress = 0;
                        model.fileName = '';
                        return;
                    }
                    if (scope.viewModel.isGeneralUpload) {
                        for (var i in scope.viewModel.variables) {
                            if (scope.viewModel.variables[i].varName === model.varName) {
                                scope.viewModel.variables.splice(i, 1);
                                break;
                            }
                        }
                    }
                    for (var i in scope.viewModel.initialVariables) {
                        if (scope.viewModel.initialVariables[i].varName === model.varName) {
                            model.file = scope.viewModel.initialVariables[i].file;
                            model.fileUploadProgress = angular.copy(scope.viewModel.initialVariables[i].fileUploadProgress);
                            model.fileName = angular.copy(scope.viewModel.initialVariables[i].fileName);
                            model.src = angular.copy(scope.viewModel.initialVariables[i].src);
                            // if (isExternal) {
                            //     model.src = scope.viewModel.initialVariables[i].src;
                            // }
                            scope.viewModel.selectedVar = null;
                            break;
                        }
                    }
                };
                scope.selectVar = function (model, field) {
                    if (scope.viewModel.isGeneralUpload && field === 'src') {
                        return;
                    }
                    if (scope.viewModel.selectedVar !== model.varName) {
                        scope.viewModel.selectedVar = model.varName;
                        scope.viewModel.editedField = null;
                        return;
                    }
                    scope.viewModel.editedField = field;
                    if (scope.viewModel.modelForRevert && scope.viewModel.modelForRevert.varName === model.varName) {
                        return;
                    }
                    scope.viewModel.modelForRevert = angular.copy(model);
                };
                scope.selectVarByFile = function (file) {
                    console.info('selectVarByFile', file);
                    for (var i in scope.viewModel.variables) {
                        if (scope.viewModel.variables[i].file && scope.viewModel.variables[i].file.alias === file.alias) {
                            scope.selectVar(scope.viewModel.variables[i], 'fileName');
                            scope.selectVar(scope.viewModel.variables[i], 'fileName');
                            return;
                        }
                    }
                    //selectVar(variable, 'fileName')
                };
                var _imageNameIsChangedTimeout;
                scope.imageNameIsChanged = function (model) {
                    if (_imageNameIsChangedTimeout) {
                        $timeout.cancel(_imageNameIsChangedTimeout);
                    }
                    _imageNameIsChangedTimeout = $timeout(function () {
                        _imageNameIsChangedTimeout = null;
                        scope.viewModel.isEdited = true;
                        // model.src = baseImageUrl + scope.getUserFolder() + encodeURIComponent(model.fileName);
                        model.src = baseImageUrl + scope.getUserFolder() + model.fileName;
                        scope.checkImageNameOnExistence(model);
                    }, 500);
                };
                scope.checkImageNameOnExistence = function (model) {
                    var checkImageNameOnExistence = templateService.checkImageNameOnExistence;
                    var fileName = angular.copy(model.fileName);
                    fileName = scope.getUserFolder() + fileName;
                    checkImageNameOnExistence(fileName, scope.getUserFolder())
                        .then(function (res) {
                        model.isFileNameExist = res.isFileNameExist;
                        model.imageNameIncorrect = res.imageNameIncorrect;
                        scope.viewModel.imageNameIncorrect = res.imageNameIncorrect;
                    }, function (err) {
                    });
                };
                var _timeout;
                scope.imageUrlIsChanged = function (model) {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        if (scope.isExternalFile(model.src)) {
                            scope.removeImage(model, true);
                        }
                        else {
                            model.fileName = scope.getFileNameBasedOnUrl(model.src);
                            scope.imageNameIsChanged(model, scope.isExternalFile(model.src));
                        }
                        scope.viewModel.isEdited = true;
                    }, 1000);
                };
                scope.getListOfEditedVariables = function () {
                    var tmpVar = [];
                    for (var i in scope.viewModel.variables) {
                        for (var x in scope.viewModel.initialVariables) {
                            if (scope.viewModel.variables[i].varName !== scope.viewModel.initialVariables[x].varName || scope.viewModel.variables[i].isAlreadyOnServer) {
                                continue;
                            }
                            var variableModel = scope.viewModel.variables[i];
                            if (scope.viewModel.initialVariables[x].fileName !== variableModel.fileName ||
                                scope.viewModel.initialVariables[x].src !== variableModel.src ||
                                variableModel.file) {
                                if (scope.isExternalFile(variableModel.src) && (variableModel.file && angular.isDefined(variableModel.file.alias))) {
                                    templateService.cancelUploadImageFile(variableModel.file.alias);
                                    variableModel.file = null;
                                }
                                tmpVar.push({
                                    fileName: scope.getUserFolder() + variableModel.fileName,
                                    tmpFileName: (variableModel.file && angular.isDefined(variableModel.file.alias)) ? variableModel.file.alias : null,
                                    variableName: 'template.' + variableModel.varName,
                                    variableValue: variableModel.src
                                });
                            }
                        }
                    }
                    return tmpVar;
                };
                scope.clearModelAfterApply = function () {
                    for (var i in scope.viewModel.variables) {
                        scope.viewModel.variables[i].file = null;
                        scope.viewModel.variables[i].fileUploadProgress = 0;
                    }
                };
                scope.useImages = function () {
                    var useImagesList = scope.getListOfEditedVariables();
                    var updatedModel = {
                        useImagesList: useImagesList,
                        templateDefaultContent: JSON.stringify(scope.getUpdatedDbModel(useImagesList)),
                    };
                    if (!templateService.model.currentTemplate || !templateService.model.currentTemplate.templateId) {
                        scope.success({});
                        return;
                    }
                    updatedModel.templateId = templateService.model.currentTemplate.templateId;
                    //$rootScope.$broadcast('templateImages:changed', {});
                    //scope.clearModelAfterApply();
                    //scope.success({});
                    templateService.useImages(updatedModel)
                        .then(function (res) {
                        $rootScope.$broadcast('templateImages:changed', {});
                        scope.clearModelAfterApply();
                        scope.success({});
                    }, function (err) {
                    });
                };
                scope.uploadImages = function () {
                    var saveMethod = templateService.useImages;
                    saveMethod({ useImagesList: scope.getListOfEditedVariables() })
                        .then(function (res) {
                        scope.viewModel.isImagesUploaded = true;
                        for (var i in scope.viewModel.variables) {
                            scope.viewModel.variables[i].isAlreadyOnServer = true;
                            scope.viewModel.variables[i].wasJustUploaded = true;
                            scope.viewModel.variables[i].fileUploadProgress = 0;
                        }
                    });
                };
                scope.getUpdatedDbModel = function (useImagesList) {
                    console.log('updateDbModelAndCloseDialog', useImagesList, '---', templateService.previewModel.inDb);
                    for (var i in useImagesList) {
                        for (var x in templateService.previewModel.inDb) {
                            if ('template.' + x === useImagesList[i].variableName) {
                                templateService.previewModel.inDb[x] = useImagesList[i].variableValue;
                                break;
                            }
                        }
                    }
                    return templateService.previewModel.inDb;
                };
                scope.externalUrlIsEntered = function () {
                    for (var i in scope.viewModel.variables) {
                        if (scope.isExternalFile(scope.viewModel.variables[i].src)) {
                            return true;
                        }
                    }
                    return false;
                };
                scope.discardChanges = function () {
                    for (var i in scope.viewModel.variables) {
                        scope.removeImage(scope.viewModel.variables[i]);
                    }
                };
                scope.cancelEditing = function () {
                    if (!scope.viewModel.isEdited || scope.viewModel.variables.length === 0) {
                        scope.cancel();
                        return;
                    }
                    dialogs.confirm('Cancel editing', 'You have unsaved data that will be lost. Are you sure you want to discard the changes?')
                        .result.then(function () {
                        scope.discardChanges();
                        scope.cancel();
                    });
                };
                /**
                 * true if image has been just uploaded
                 */
                scope.isImageJustUploaded = function (imageName) {
                    var isUploaded = false;
                    scope.viewModel.variables.forEach(function (item) {
                        if (item.fileName === imageName) {
                            if (angular.isDefined(item.wasJustUploaded) && item.wasJustUploaded === true) {
                                isUploaded = true;
                            }
                        }
                    });
                    return isUploaded;
                };
                scope.previewImage = function (variable) {
                    var timeStamp = new Date().getTime();
                    var imageUrl = false;
                    var previewImagePath;
                    if (scope.isImageJustUploaded(variable.fileName)) {
                        // Use native name if image is already uploaded
                        previewImagePath = scope.getUserFolder() + variable.fileName;
                    }
                    else {
                        try {
                            // Use temporary path
                            previewImagePath = variable.file.alias;
                        }
                        catch (e) {
                            // file.alias is not set, so we suggest, it is a much earlier uploaded image.
                            // Use native name and extra path
                            if (angular.isDefined(variable.isAlreadyOnServer) && variable.isAlreadyOnServer) {
                                // There is no need to construct a path in this case because of image is requested from images.autoremind.us via html link
                            }
                        }
                    }
                    if (variable.file) {
                        imageUrl = '/servlets/templates/download/?fileName=' + previewImagePath + '&' + timeStamp;
                    }
                    else {
                        imageUrl = variable.src + '?' + timeStamp;
                    }
                    templateService.previewImage(imageUrl);
                };
                scope.usersFolderChanged = function () {
                    for (var i in scope.viewModel.variables) {
                        // scope.viewModel.variables[i].src = baseImageUrl + scope.getUserFolder() + encodeURIComponent(scope.viewModel.variables[i].fileName);
                        scope.viewModel.variables[i].src = baseImageUrl + scope.getUserFolder() + scope.viewModel.variables[i].fileName;
                        scope.checkImageNameOnExistence(scope.viewModel.variables[i]);
                    }
                };
                scope.importImage = function () {
                };
                scope.defaultUploadImage = function (files) {
                    scope.viewModel.isImagesUploaded = false;
                    files.forEach(function (file) {
                        var model = scope.viewModel.variables[scope.createVariable()];
                        scope.uploadImage(model, file);
                    });
                };
                scope.showUploadImages = function (model) {
                    if (!model) {
                        model = scope.viewModel.variables[scope.createVariable()];
                    }
                    var modalInstance;
                    var modalScope = scope.$new();
                    modalScope.type = scope.config.type;
                    modalScope.success = function (result) {
                        if (result) {
                            if (!scope.viewModel.isGeneralUpload) {
                                scope.removeImage(model, false);
                            }
                            else {
                                model.fileUploadProgress = 0;
                            }
                            model.isAlreadyOnServer = true;
                            model.src = baseImageUrl + result.path + result.file;
                            model.fileName = scope.getFileNameBasedOnUrl(model.src);
                            scope.viewModel.isEdited = true;
                        }
                        modalInstance.close(modalScope.selected);
                    };
                    modalScope.cancel = function () {
                        scope.removeImage(model, false);
                        modalInstance.dismiss('cancel');
                    };
                    modalInstance = $uibModal.open({
                        template: '<browse-uploaded-images></browse-uploaded-images>',
                        size: 'lg',
                        scope: modalScope,
                        backdrop: 'static'
                    });
                };
            }
        };
    }]);
//# sourceMappingURL=upload-select-images.directive.js.map